import { render, staticRenderFns } from "./MobileCommunityUnitBusinessNews.vue?vue&type=template&id=8c40ea24&scoped=true&"
import script from "./MobileCommunityUnitBusinessNews.vue?vue&type=script&lang=js&"
export * from "./MobileCommunityUnitBusinessNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c40ea24",
  null
  
)

export default component.exports